import * as React from 'react'

import * as styles from './raster.css'

export class Raster extends React.Component {

  render () {
    return (
      <div className={styles.raster}></div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/elements/raster.tsx